import { Chip, Tooltip } from '@bp/ui-components';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { ColorType } from '../../types/global';
import styles from './Page.module.scss';

type PageHeaderProps = {
  headline?: string | null;
  subHeadline?: string | number | null;
  showSubHeadlineAsChip?: boolean;
  chipTooltip?: string;
  colorHint?: ColorType;
  /** Steht hinter der Überschrift, z. B. das Schloss eines nicht gebuchten Moduls. */
  headlineAddon?: ReactNode;
  size?: 's' | 'm' | 'l';
  noMargin?: boolean;
  isModal?: boolean;
  isForm?: boolean;
  bigActionsGap?: boolean;
  className?: string | undefined;
};

export const PageHeader: FC<PageHeaderProps> = ({
  headline,
  subHeadline,
  showSubHeadlineAsChip = false,
  chipTooltip,
  colorHint,
  headlineAddon,
  size = 'm',
  noMargin = false,
  isModal = false,
  isForm = false,
  bigActionsGap = false,
  className,
}) => {
  const classes = classNames(
    styles['page-header'],
    styles[`size-${size}`],
    {
      [styles['no-margin']]: noMargin,
      'bp__form-header': isForm,
      'bp__modal-header': isModal,
      [styles['big-gap']]: bigActionsGap,
      [styles['with-chip']]: showSubHeadlineAsChip,
    },
    className,
  );

  return (
    <div className={classes}>
      <div className={styles['headline-wrapper']}>
        {headline && (
          <div className={styles.headline}>
            {headline}
            {colorHint && (
              <Tooltip content={colorHint.colorLabel}>
                <span
                  className={styles.color}
                  style={{
                    backgroundColor: colorHint.color ?? '#FFF',
                  }}
                />
              </Tooltip>
            )}
            {headlineAddon}
          </div>
        )}
        {(subHeadline || subHeadline === 0) && (
          <>
            {showSubHeadlineAsChip ? (
              chipTooltip ? (
                <Tooltip content={chipTooltip} className={styles.tooltip}>
                  <Chip
                    className={styles.subline}
                    value={subHeadline.toString()}
                    maxWidth='100%'
                    bgColor='var(--color-primary-light)'
                    color='var(--color-grey)'
                  />
                </Tooltip>
              ) : (
                <Chip
                  className={styles.subline}
                  value={subHeadline.toString()}
                  maxWidth='100%'
                  bgColor='var(--color-primary-light)'
                  color='var(--color-grey)'
                />
              )
            ) : (
              <div className={styles.subline}>{subHeadline.toString()}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
